export default {"src":"/_next/static/image/public/images/flags/flag_36.0c0d4ea96d1607afb35d749b7e264b54.svg","height":16,"width":24};